import { render } from "./SurveyGroupList.vue?vue&type=template&id=1de7817c"
import script from "./SurveyGroupList.vue?vue&type=script&lang=js"
export * from "./SurveyGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__